import { CircularProgress, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useOktaAuth } from '@okta/okta-react';
import axios2 from 'axios';
import PropTypes from 'prop-types';
import React, { Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { renderRoutes } from 'react-router-config';
import { Switch, useHistory } from 'react-router-dom';
import routes from 'src/routes';
import {
  setAuthorizedUserToLs,
  setIpAddress,
  setSessionToken,
  setUserSession
} from 'src/utils/Common';
import Topbar from './Topbar';
import NotificationSnackbar from 'src/components/NotificationSnackbar';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: {
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56
    }
  }
}));

function Auth() {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const [Loading, setLoading] = React.useState(true);
  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  };
  const history = useHistory();
  const { oktaAuth, authState } = useOktaAuth();

  navigator.geolocation.getCurrentPosition(success, error, options);
  function success(pos) {
    // var crd = pos.coords;
  }

  function error(err) { }

  useEffect(() => {
    if (!authState.isPending && authState.isAuthenticated) {
      oktaAuth.getUser().then(info => {
        if (info === undefined) {
          const fromUri = history.createHref(history.location);
          oktaAuth.signInWithRedirect(fromUri);
        }
        const UserNames = info?.preferred_username.split('@');
        const dataUser = [
          {
            UserName: UserNames[0],
            Password: '',
            TerminalId: '1',
            VersionNr: process.env.REACT_APP_VERSION,
            TerminalIp: '1',
            LanguageId: '1'
          }
        ];

        const configUser = {
          headers: {
            'Content-Type': 'application/json',
            IpAddress: 1,
            'max-age': 86400,
            'X-Frame-Options': 'DENY',
            'X-XSS-Protection': '1; mode=block',
            accessToken: authState.accessToken.accessToken,
            Authorization: `Bearer ${authState.accessToken.accessToken}`,
            Language: localStorage.getItem('i18nextLng')
          }
        };

        const Address = `${process.env.REACT_APP_API_URL}/Technician/GetUserAuthorization`;
        axios2
          .post(Address, dataUser, configUser)
          .then(response => {
            setAuthorizedUserToLs(JSON.stringify(response?.data[0]));
            if (response.data[0].Role === 3 || 
                response.data[0].Role === 5 || 
                (response.data[0].Role === 4 && !(response.data[0]?.TenantId === 75 && response.data[0]?.IsRegionZoneService))) {
              setSessionToken(
                authState.accessToken.accessToken,
                response.data[0].SessionTokenWs || ''
              );
              setIpAddress(1);
              setUserSession(
                authState.accessToken.accessToken,
                response.data[0].SessionTokenWs || '',
                response.data[0]
              );
              setLoading(false);
              setLoading(false);
              const redirect = localStorage.getItem('redirect');
              if (redirect) {
                localStorage.removeItem('redirect');
                history.push(JSON.parse(redirect));
              }
              else {
                history.push('/overview');
              }
            } else {
              setUserSession(
                authState.accessToken.accessToken,
                response.data[0].SessionTokenWs || '',
                response.data[0]
              );
              setLoading(false);
              history.push('/Unauthorized');
            }

          })
          .catch(error => {
            setLoading(false);
            history.push('/Unauthorized');
          });
      });
    }
    if (!authState.isPending && !authState.isAuthenticated) {
      const fromUri = history.createHref(history.location);
      oktaAuth.signInWithRedirect(fromUri);
    }
  }, []);


  return (
    <>
      <Topbar />
      <div className={classes.container}>
        <div className={classes.content}>
          {Loading && (
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justify="center"
              style={{ minHeight: '100vh' }}
            >
              <Typography component="h2" gutterBottom variant="overline">
                {t('Yonlendiriliyorsunuz')}
              </Typography>
              <CircularProgress disableShrink />
            </Grid>
          )}

          <NotificationSnackbar />
          <Suspense fallback={null}>
            <Switch>{renderRoutes(routes)}</Switch>
          </Suspense>
        </div>
      </div>
    </>
  );
}

Auth.propTypes = {
  route: PropTypes.object
};

export default Auth;
